// extracted by mini-css-extract-plugin
module.exports = {"container":"antd-pro-components-form-widgets-date-picker-index-container","label":"antd-pro-components-form-widgets-date-picker-index-label"};